import { ConversationPost } from '../types/agent';
import api from './utils/axios';
import generateCRUDOps from './utils/generateCrud';

const pathPrefix = `/agentos/`;

const PromptService = {
  // Use actual CRUD operations
  ...generateCRUDOps(pathPrefix, 'prompts'),

  // Custom endpoints with real implementation
  getResolvedPrompt: async (promptId: number) => {
    const response = await api.get(
      `${pathPrefix}prompts/${promptId}/?decode=true`
    );
    return response.data;
  },
  runPrompt: async (promptId: number, userMessage: string) => {
    const response = await api.post(`${pathPrefix}prompts/${promptId}/run/`, {
      user_message: userMessage,
    });
    return response.data;
  },

  addToConversation: async (promptId: number, posts: ConversationPost) => {
    const response = await api.post(
      `${pathPrefix}prompts/${promptId}/add-conversation/`,
      posts
    );
    return response.data;
  },

  getPosts: async (promptId: number) => {
    const response = await api.get(`${pathPrefix}prompts/${promptId}/posts/`);
    return response.data;
  },

  deletePost: async (promptId: number, postId: number) => {
    const response = await api.delete(
      `${pathPrefix}prompts/${promptId}/posts/${postId}/`
    );
    return response.data;
  },
};

export default PromptService;
